// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"524051c8","455":"944875d4","977":"032cee08"}[chunkId] + ".chunk.js";
};